import { useQuery } from '@apollo/client';

import { UNREAD_NOTIFICATION_COUNT_QUERY } from '../graphql/queries';

/** How often the badge re-checks for new notifications, in the absence of live push (ADR-0020). */
const POLL_INTERVAL_MS = 30_000;

/**
 * The unread notification count behind the bell badge. `skip` turns it off for signed-out shells (the
 * bell only renders when authenticated). The count refreshes immediately when a read/mark-all mutation
 * invalidates it (via `refetchQueries`), and otherwise polls every {@link POLL_INTERVAL_MS} — a new
 * notification (e.g. a shortlist) would otherwise sit invisible on the badge until the user happened to
 * open the drawer or mark something read, since nothing else was refreshing it. No live push yet
 * (subscriptions are deferred platform-wide pending the Gateway's WebSocket auth, ADR-0020 Decision 6).
 */
export function useUnreadNotificationCount(skip = false) {
  const { data, previousData, refetch } = useQuery(UNREAD_NOTIFICATION_COUNT_QUERY, {
    fetchPolicy: 'cache-and-network',
    pollInterval: POLL_INTERVAL_MS,
    skip,
  });

  const count = (data ?? previousData)?.unreadNotificationCount ?? 0;

  return { count, refetch };
}
